(function () {
  if (window.TuffQuickbuyFeedbackLoaded) return;
  window.TuffQuickbuyFeedbackLoaded = true;

  var styleId = "tuff-quickbuy-feedback-styles";
  var recentProductForm = null;
  var recentProductSubmitAt = 0;

  function injectStyles() {
    if (document.getElementById(styleId)) return;
    var style = document.createElement("style");
    style.id = styleId;
    style.textContent = [
      ".tuff-qb-feedback{display:grid;grid-template-columns:auto 1fr;gap:11px;margin:0 0 16px;padding:13px 14px;border:1px solid #111;background:#fff;color:#111;font-size:14px;line-height:1.35;border-radius:3px;box-shadow:0 2px 0 #111;}",
      ".tuff-qb-feedback--error{border-color:#b91c1c;background:#fef2f2;color:#991b1b;box-shadow:0 2px 0 #b91c1c;}",
      ".tuff-qb-feedback__mark{display:flex;align-items:center;justify-content:center;width:24px;height:24px;margin-top:1px;border:1px solid currentColor;border-radius:50%;font-size:13px;font-weight:800;line-height:1;}",
      ".tuff-qb-feedback__title{font-weight:900;margin:0 0 3px;text-transform:uppercase;letter-spacing:0;font-size:13px;}",
      ".tuff-qb-feedback__text{margin:0;color:inherit;opacity:.78;}",
      ".tuff-qb-feedback__actions{grid-column:2;display:flex;gap:8px;flex-wrap:wrap;margin-top:11px;}",
      ".tuff-qb-feedback__action{display:inline-flex;align-items:center;justify-content:center;min-height:34px;padding:8px 12px;border:1px solid currentColor;color:inherit;text-decoration:none;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:0;}",
      ".tuff-qb-feedback__action--primary{background:#111;color:#fff;border-color:#111;}",
      ".tuff-qb-feedback--error .tuff-qb-feedback__action--primary{background:#991b1b;color:#fff;border-color:#991b1b;}",
      ".tuff-qb-button-added{background:#111!important;border-color:#111!important;color:#fff!important;}",
      "@media (max-width: 767px){.tuff-qb-feedback{font-size:13px;margin-bottom:14px;padding:12px}.tuff-qb-feedback__actions{display:grid;grid-template-columns:1fr 1fr}.tuff-qb-feedback__action{width:100%;padding-inline:8px}}"
    ].join("");
    document.head.appendChild(style);
  }

  function cartUrl() {
    return window.theme && window.theme.routes && window.theme.routes.cart ? window.theme.routes.cart : "/cart";
  }

  function findQuickbuyContainer(source) {
    if (!source || !source.closest) return null;
    return source.closest(".quickbuy-container");
  }

  function rememberProductForm(source) {
    var productForm = source && source.matches && source.matches("product-form") ? source : source && source.closest ? source.closest("product-form") : null;
    if (!productForm || !findQuickbuyContainer(productForm)) return null;
    recentProductForm = productForm;
    recentProductSubmitAt = Date.now();
    return productForm;
  }

  function activeProductForm() {
    if (recentProductForm && document.documentElement.contains(recentProductForm) && Date.now() - recentProductSubmitAt < 30000) {
      return recentProductForm;
    }
    return document.querySelector(".product-block.expanded .quickbuy-container product-form")
      || document.querySelector(".quickbuy-container product-form");
  }

  function findFeedbackMount(productForm) {
    if (!productForm) return null;
    var button = productForm.querySelector('[name="add"]');
    var buttonParent = button ? button.closest(".payment-buttons, .product-form__buttons, .product-detail__form__action, .btn-row, .button-row") : null;
    return buttonParent || productForm;
  }

  function findTopMount(container, productForm) {
    if (!container) return null;
    for (var i = 0; i < container.children.length; i += 1) {
      if (container.children[i].classList && container.children[i].classList.contains("inner")) return container.children[i];
    }
    return productForm || container;
  }

  function removeExisting(container) {
    container.querySelectorAll(".tuff-qb-feedback").forEach(function (node) {
      node.remove();
    });
  }

  function renderFeedback(productForm, state, message) {
    productForm = productForm || activeProductForm();
    var container = findQuickbuyContainer(productForm);
    if (!container) return;

    injectStyles();
    removeExisting(container);
    setButtonState(productForm, state);

    var mount = state === "error" ? findFeedbackMount(productForm) : findTopMount(container, productForm);
    if (!mount) return;

    var feedback = document.createElement("div");
    feedback.className = state === "error" ? "tuff-qb-feedback tuff-qb-feedback--error" : "tuff-qb-feedback";
    feedback.setAttribute("role", state === "error" ? "alert" : "status");
    feedback.setAttribute("aria-live", "polite");

    var title = state === "error" ? "Could not add to cart" : "Added to cart";
    var text = message || (state === "error" ? "Please check your selections and try again." : "Your item was added successfully.");

    feedback.innerHTML = [
      '<span class="tuff-qb-feedback__mark" aria-hidden="true">' + (state === "error" ? "!" : "&#10003;") + "</span>",
      "<div>",
      '<p class="tuff-qb-feedback__title">' + escapeHtml(title) + "</p>",
      '<p class="tuff-qb-feedback__text">' + escapeHtml(text) + "</p>",
      '<div class="tuff-qb-feedback__actions">',
      '<a class="tuff-qb-feedback__action tuff-qb-feedback__action--primary" href="' + escapeAttr(cartUrl()) + '">View cart</a>',
      '<a class="tuff-qb-feedback__action" href="/checkout">Checkout</a>',
      "</div>",
      "</div>"
    ].join("");

    if (state === "error") {
      mount.insertAdjacentElement("afterend", feedback);
    } else {
      mount.insertAdjacentElement("afterbegin", feedback);
    }
  }

  function setButtonState(productForm, state) {
    if (!productForm) return;
    var button = productForm.querySelector('[name="add"]');
    if (!button) return;
    if (!button.dataset.tuffQbOriginalHtml) button.dataset.tuffQbOriginalHtml = button.innerHTML;
    if (state === "success") {
      button.classList.add("tuff-qb-button-added");
      button.innerHTML = "Added to cart";
      window.clearTimeout(button.__tuffQbRestoreTimer);
      button.__tuffQbRestoreTimer = window.setTimeout(function () {
        button.classList.remove("tuff-qb-button-added");
        if (button.dataset.tuffQbOriginalHtml) button.innerHTML = button.dataset.tuffQbOriginalHtml;
      }, 3000);
    } else if (button.dataset.tuffQbOriginalHtml) {
      button.classList.remove("tuff-qb-button-added");
      button.innerHTML = button.dataset.tuffQbOriginalHtml;
    }
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[char];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, "&#96;");
  }

  document.addEventListener("on:cart:add", function (event) {
    var productForm = rememberProductForm(event.target);
    renderFeedback(productForm, "success", "Your item is in the cart.");
  }, true);

  document.addEventListener("on:cart:error", function (event) {
    var productForm = rememberProductForm(event.target);
    var message = event.detail && event.detail.error ? event.detail.error : "";
    renderFeedback(productForm, "error", message);
  }, true);

  document.addEventListener("submit", function (event) {
    rememberProductForm(event.target);
  }, true);

  function bodyValue(body, name) {
    if (!body || !name) return null;
    try {
      if (window.FormData && body instanceof FormData) return body.get(name);
      if (window.URLSearchParams && body instanceof URLSearchParams) return body.get(name);
      if (typeof body === "string") return new URLSearchParams(body).get(name);
    } catch (error) {}
    return null;
  }

  function isCartAddUrl(input) {
    var raw = typeof input === "string" ? input : input && input.url ? input.url : "";
    if (!raw) return false;
    try {
      return new URL(raw, window.location.origin).pathname.indexOf("/cart/add") === 0;
    } catch (error) {
      return raw.indexOf("/cart/add") >= 0;
    }
  }

  function parseCartError(payload) {
    if (!payload) return "";
    if (typeof payload.description === "string") return payload.description;
    if (typeof payload.message === "string") return payload.message;
    if (payload.errors && typeof payload.errors === "object") {
      try {
        return Object.keys(payload.errors).map(function (key) {
          var value = payload.errors[key];
          return Array.isArray(value) ? value.join(", ") : String(value);
        }).join(", ");
      } catch (error) {}
    }
    return "";
  }

  function showCartResult(ok, payload, body) {
    if (Date.now() - recentProductSubmitAt > 30000) return;
    var message = ok ? "Your item is in the cart." : parseCartError(payload) || "Please check your selections and try again.";
    renderFeedback(activeProductForm(), ok ? "success" : "error", message);
  }

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var isCartAdd = isCartAddUrl(input);
      var body = init && init.body ? init.body : input && input.body ? input.body : null;
      var result = originalFetch.apply(this, arguments);
      if (!isCartAdd) return result;

      return result.then(function (response) {
        var clone = response.clone();
        clone.json().then(function (json) {
          showCartResult(response.ok && !json.status, json, body);
        }).catch(function () {
          showCartResult(response.ok, null, body);
        });
        return response;
      }).catch(function (error) {
        showCartResult(false, { message: error && error.message ? error.message : "Unable to add this item." }, body);
        throw error;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__tuffQbFeedbackUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (isCartAddUrl(this.__tuffQbFeedbackUrl)) {
        var xhr = this;
        xhr.addEventListener("loadend", function () {
          var parsed = null;
          try {
            parsed = xhr.responseText ? JSON.parse(xhr.responseText) : null;
          } catch (error) {}
          showCartResult(xhr.status >= 200 && xhr.status < 300, parsed, body);
        });
      }
      return originalSend.apply(this, arguments);
    };
  }
})();
